import { NotificationSettingsFormValues } from '../../components/notifications-settings/types';
import { appAPI } from '.';
import { ApiTags } from './appApi';
import { notify } from '../../clients/ApiService';

const notificationsSettingsApi = appAPI.injectEndpoints({
  endpoints: build => ({
    getNotificationsSettings: build.query<NotificationSettingsFormValues, void>(
      {
        query: () => ({
          path: '/notification-settings',
          method: 'get',
          options: {},
        }),
        providesTags: [ApiTags.notifications_settings],
      },
    ),
    updateNotificationsSettings: build.mutation<
      NotificationSettingsFormValues,
      unknown
    >({
      query: body => ({
        path: '/notification-settings',
        method: 'post',
        options: {
          body,
        },
      }),
      async onQueryStarted(data, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsSettingsApi.util.updateQueryData(
            'getNotificationsSettings',
            undefined,
            draft => {
              // eslint-disable-next-line no-param-reassign
              draft = data;
            },
          ),
        );
        try {
          await queryFulfilled;
          notify({
            status: 'success',
            successMessage: 'Notification preferences saved.',
            dispatch,
          });
        } catch (error) {
          patchResult.undo();
          notify({
            status: 'error',
            errorMessage: 'The notification settings cannot be updated.',
            error,
            dispatch,
          });
        }
      },
      invalidatesTags: [ApiTags.notifications_settings], // refetch get notification settings data
    }),
  }),
});

export const {
  useGetNotificationsSettingsQuery,
  useUpdateNotificationsSettingsMutation,
} = notificationsSettingsApi;
